(function(){'use strict';function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}function normalizeMultiplierValue(t){if(null==t)return 1;if("number"==typeof t)return Number.isFinite(t)&&t>0?t:1;if("string"==typeof t){var e=t.trim();if(!e)return 1;var n=parseFloat(e.replace(",","."));return Number.isFinite(n)&&n>0?n:1}return 1}function getProductPriceMultiplier(){var t,e,n;return normalizeMultiplierValue(null===(t=window.themeVariables)||void 0===t||null===(e=t.pricingDiscounts)||void 0===e||null===(n=e.multipliers)||void 0===n?void 0:n.product)}function normalizePropertyValue(t){return null==t?"":String(t)}function buildSingleFinishKeyFromValues(t,e){var n=[],i=normalizePropertyValue(t),a=normalizePropertyValue(e);return i&&n.push("tiers:".concat(i)),a&&n.push("setup:".concat(a)),n.length>0?"single:".concat(n.join("|")):""}function buildSetFinishKeyFromValues(t){for(var e=[],n=1;n<=5;n+=1){var i=normalizePropertyValue(t(n,"tiers")),a=normalizePropertyValue(t(n,"setupFee"));(i||a)&&e.push([i,a].join("|"));}return e.length>0?"set:".concat(e.join("||")):""}function buildFinishKeyFromProperties(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=buildSetFinishKeyFromValues((function(e,n){var i="tiers"===n?"Finish_Tiers":"Finish_Setup_Fee";return t["_Set_Component_".concat(e,"_").concat(i)]}));if(e)return e;var n=t._Finish_Tiers,i=t._Finish_Setup_Fee;return buildSingleFinishKeyFromValues(n,i)}function buildCartQuantityMap(t){var e={};return Array.isArray(t)?(t.forEach((function(t){if(t&&null!=t.variant_id){var n=parseInt(t.quantity,10);if(Number.isFinite(n)&&!(n<=0)){var i=buildFinishKeyFromProperties(t.properties||{}),a="".concat(t.variant_id,"|").concat(i);e[a]=(e[a]||0)+n;}}})),e):e}var CatalogQuantitySelector=function(t){_inherits(a,t);var e,n,i=_createSuper(a);function a(){return _classCallCheck(this,a),i.apply(this,arguments)}return _createClass(a,[{key:"connectedCallback",value:function(){var t,e,n,i,a,r,l,u,o,s,c=this;this.abortController=new AbortController,this.inputElement=this.querySelector("input"),this.variantDataById=this.parseVariantData(),this.checkboxElement=this.findCheckboxElement(),this.catalogStep=(null===(t=this.inputElement)||void 0===t?void 0:t.dataset.catalogIncrement)||(null===(e=this.inputElement)||void 0===e?void 0:e.step)||"1",this.defaultStep=(null===(n=this.inputElement)||void 0===n?void 0:n.dataset.singleStep)||(null===(i=this.inputElement)||void 0===i?void 0:i.dataset.defaultStep)||(null===(a=this.inputElement)||void 0===a?void 0:a.step)||"1",this.catalogMin=(null===(r=this.inputElement)||void 0===r?void 0:r.dataset.catalogMin)||(null===(l=this.inputElement)||void 0===l?void 0:l.getAttribute("min"))||"1",this.singleItemMin=(null===(u=this.inputElement)||void 0===u?void 0:u.dataset.singleMin)||(null===(o=this.inputElement)||void 0===o?void 0:o.dataset.defaultMin)||"1",this.inputController=this.handleManualInput.bind(this),this.commitController=this.handleCommittedInput.bind(this),this.exitController=this.handleManualInputExit.bind(this),this.keydownController=this.handleManualInputKeydown.bind(this),this.variantId=this.getVariantId(),this.quantityPriceBreaks=this.parseQuantityPriceBreaks(),this.defaultPrice=this.dataset.defaultPrice?parseFloat(this.dataset.defaultPrice):0,this.updateVariantPricingData(this.variantId),0===this.quantityPriceBreaks.length&&window.variant&&window.variant.quantity_price_breaks&&(this.quantityPriceBreaks=window.variant.quantity_price_breaks.map((function(t){return {min:t.minimum_quantity,price:t.price}})),this.defaultPrice=window.variant.price||this.defaultPrice),this.cartQuantity=0,this.cartQuantitiesByKey={},this.initializeWithCartData();var d=function(){c.isConnected&&c.fetchCartQuantity().then((function(){c.isConnected&&c.updatePrice();}));};document.addEventListener("visibilitychange",(function(){document.hidden||d();}),{signal:this.abortController.signal}),document.addEventListener("cart:change",d,{signal:this.abortController.signal}),document.addEventListener("cart:refresh",d,{signal:this.abortController.signal}),document.addEventListener("line-item:change",d,{signal:this.abortController.signal}),this.checkboxElement&&this.checkboxElement.addEventListener("change",this.onCheckboxChange.bind(this),{signal:this.abortController.signal}),this.querySelector("button:first-of-type").addEventListener("click",this.stepDown.bind(this),{signal:this.abortController.signal}),this.querySelector("button:last-of-type").addEventListener("click",this.stepUp.bind(this),{signal:this.abortController.signal}),this.inputElement&&(this.inputElement.addEventListener("input",this.inputController,{signal:this.abortController.signal}),this.inputElement.addEventListener("change",this.commitController,{signal:this.abortController.signal}),this.inputElement.addEventListener("blur",this.exitController,{signal:this.abortController.signal}),this.inputElement.addEventListener("keydown",this.keydownController,{signal:this.abortController.signal}));var p=null===(s=this.inputElement)||void 0===s?void 0:s.form;p&&(p.addEventListener("submit",(function(){c.applyCatalogValueConstraint(),c.updateCatalogProperties(!!c.checkboxElement&&c.checkboxElement.checked);}),{signal:this.abortController.signal}),p.addEventListener("change",(function(t){var e,n,i,a;(null!==(e=t.target)&&void 0!==e&&null!==(n=e.matches)&&void 0!==n&&n.call(e,'input[name="id"]')||null!==(i=t.target)&&void 0!==i&&null!==(a=i.matches)&&void 0!==a&&a.call(i,'input[name^="properties["]'))&&(c.updateVariantPricingData(),c.updatePrice());}),{signal:this.abortController.signal})),document.addEventListener("variant:change",(function(t){var e,n,i=null===(e=t.detail)||void 0===e||null===(n=e.variant)||void 0===n?void 0:n.id;i&&(c.updateVariantPricingData(i),c.updatePrice());}),{signal:this.abortController.signal}),document.addEventListener("change",(function(t){var e=t.target;e&&e.matches&&(e.matches("input[data-finish-pricing-property]")||e.matches("input[data-set-component-property]"))&&(c.updateVariantPricingData(),c.updatePrice());}),{signal:this.abortController.signal}),this.updateStep();}},{key:"findCheckboxElement",value:function(){if(this.dataset.checkboxId){var t=document.getElementById(this.dataset.checkboxId);if(t)return t}var e=this.inputElement.id.replace("-quantity","-single-item"),n=document.getElementById(e);if(n)return n;var i=this.inputElement.form;if(i){var a=Array.from(i.querySelectorAll('input[type="checkbox"]')).find((function(t){return t.id.includes("single-item")}));if(a)return a}var r=document.querySelectorAll('input[type="checkbox"][id*="single-item"]');return r.length>0?r[0]:null}},{key:"onCheckboxChange",value:function(){var t=!!this.checkboxElement&&this.checkboxElement.checked;if(this.updateStep(),this.inputElement){var e=this.singleItemMin||"1",n=t?e:this.catalogMin;this.inputElement.value=n,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0}));}this.updatePrice();}},{key:"updateStep",value:function(){var t="true"===this.inputElement.dataset.hasCatalog,e=!!this.checkboxElement&&this.checkboxElement.checked,n=t&&!e;n?(this.inputElement.step=this.getManualInputStep(),this.inputElement.min=this.getManualInputMin()):(this.inputElement.step=this.defaultStep,this.inputElement.min=this.singleItemMin),t&&(this.applyCatalogValueConstraint({force:n}),this.updateCatalogProperties(e));}},{key:"stepDown",value:function(){var t,e="true"===this.inputElement.dataset.hasCatalog,n=this.getCatalogIncrement(),i=!!this.checkboxElement&&this.checkboxElement.checked,a=e&&!i,r=a?this.getCatalogMin():parseInt(this.inputElement.min,10)||1,l=parseInt(this.inputElement.value,10);if(Number.isNaN(l)&&(l=r),l=a?this.normalizeCatalogValue(l):Math.max(r,l),a)t=l<=r?r:Math.max(r,l-n);else {var u=parseInt(this.inputElement.step,10)||1;t=Math.max(r,l-u);}t=this.applyMaxConstraint(t),this.inputElement.value=t,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0})),this.updatePrice();}},{key:"stepUp",value:function(){var t,e="true"===this.inputElement.dataset.hasCatalog,n=this.getCatalogIncrement(),i=!!this.checkboxElement&&this.checkboxElement.checked,a=e&&!i,r=this.inputElement.max?parseInt(this.inputElement.max,10):null,l=a?this.getCatalogMin():parseInt(this.inputElement.min,10)||1,u=parseInt(this.inputElement.value,10);(Number.isNaN(u)&&(u=l),u=a?this.normalizeCatalogValue(u):Math.max(l,u),a)?t=u<l?l:u+n:t=u+(parseInt(this.inputElement.step,10)||1);t=this.applyMaxConstraint(t,r),this.inputElement.value=t,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0}));}},{key:"handleManualInput",value:function(){this.updatePrice();}},{key:"handleCommittedInput",value:function(){this.commitManualInput();}},{key:"handleManualInputExit",value:function(){this.commitManualInput({notify:!0});}},{key:"handleManualInputKeydown",value:function(t){["Enter","Tab"].includes(t.key)&&this.commitManualInput({notify:!0});}},{key:"commitManualInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.notify,n=void 0!==e&&e,i=this.inputElement.value;this.applyCatalogValueConstraint(),this.updatePrice(),n&&this.inputElement.value!==i&&this.inputElement.dispatchEvent(new Event("change",{bubbles:!0}));}},{key:"getCatalogPropertyInputs",value:function(){var t=this.inputElement.form;if(!t)return [];var e=new Set;t.querySelectorAll("input[data-catalog-property]").forEach((function(t){return e.add(t)}));var n=t.getAttribute("id");return n&&document.querySelectorAll('input[data-catalog-property][form="'.concat(n,'"]')).forEach((function(t){return e.add(t)})),Array.from(e)}},{key:"updateCatalogProperties",value:function(t){var e=this,n=this.getCatalogPropertyInputs(),i=!t;n.forEach((function(t){var n=t.dataset.catalogProperty;if("mode"===n)return t.disabled=!1,void(t.value=i?"catalog":"single");i?(t.disabled=!1,"is-item"===n&&(t.value="true"),"increment"===n&&(t.value=e.getCatalogIncrement())):(t.value="",t.disabled=!0);}));}},{key:"shouldUseCatalogMode",value:function(){return !("true"!==this.inputElement.dataset.hasCatalog)&&(!this.checkboxElement||!this.checkboxElement.checked)}},{key:"normalizeCatalogValue",value:function(t){var e=parseInt(t,10),n=this.getCatalogMin(),i=this.getCatalogIncrement();if(Number.isNaN(e)||e<=n)return n;var a=e%i,r=e-a;return 0===a?Math.max(n,r):Math.max(n,r+i)}},{key:"applyCatalogValueConstraint",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.force,n=void 0!==e&&e,i=this.shouldUseCatalogMode();if((i||n)&&(i||n)){var a=this.normalizeCatalogValue(this.inputElement.value),r=this.applyMaxConstraint(a);this.inputElement.value=r;}}},{key:"applyMaxConstraint",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return e=null!==n?n:this.inputElement.max?parseInt(this.inputElement.max,10):null,Number.isInteger(e)&&t>e?e:t}},{key:"getCatalogIncrement",value:function(){return parseInt(this.inputElement.dataset.catalogIncrement,10)||1}},{key:"getCatalogMin",value:function(){return parseInt(this.catalogMin,10)||this.getCatalogIncrement()}},{key:"getManualInputStep",value:function(){return this.inputElement.dataset.singleStep||this.inputElement.dataset.defaultStep||"1"}},{key:"getManualInputMin",value:function(){return this.inputElement.dataset.singleMin||this.inputElement.dataset.defaultMin||"1"}},{key:"parseQuantityPriceBreaks",value:function(){try{var t=this.dataset.quantityPriceBreaks;return t?t.split(",").map((function(t){var e=t.split(":").map(Number),n=_slicedToArray(e,2);return {min:n[0],price:n[1]}})):[]}catch(t){return []}}},{key:"parseVariantData",value:function(){var t=this.querySelector("script[data-catalog-quantity-variants]");if(!t)return {};try{var e=JSON.parse(t.textContent||"{}");return e&&"object"===_typeof(e)?e:{}}catch(t){return {}}}},{key:"getVariantId",value:function(){var t,e=null===(t=this.inputElement)||void 0===t?void 0:t.form;if(e){var n=e.querySelector('input[name="id"]');if(n)return parseInt(n.value,10)}var i=new URLSearchParams(window.location.search).get("variant");return i?parseInt(i,10):window.variant&&window.variant.id?window.variant.id:null}},{key:"getCurrentVariantId",value:function(){var t,e=null===(t=this.inputElement)||void 0===t?void 0:t.form;if(e){var n=e.querySelector('input[name="id"]');if(null!=n&&n.value){var i=parseInt(n.value,10);if(Number.isFinite(i))return i}}return this.getVariantId()}},{key:"updateVariantPricingData",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=t||this.getCurrentVariantId();if(e){this.variantId=parseInt(e,10);var n=this.variantDataById[String(e)];n&&(this.defaultPrice=Number.isFinite(Number(n.price))?Number(n.price):this.defaultPrice,this.quantityPriceBreaks=Array.isArray(n.tiers)?n.tiers.map((function(t){return {min:parseInt(t.min,10),price:Number(t.price)}})).filter((function(t){return Number.isFinite(t.min)&&Number.isFinite(t.price)})):[]);}}},{key:"initializeWithCartData",value:(n=_asyncToGenerator(_regeneratorRuntime().mark((function t(){return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,this.fetchCartQuantity();case 2:this.isConnected&&this.getCartQuantityForCurrentSelection()>0&&this.updatePrice();case 3:case"end":return t.stop()}}),t,this)}))),function(){return n.apply(this,arguments)})},{key:"fetchCartQuantity",value:(e=_asyncToGenerator(_regeneratorRuntime().mark((function t(){var e,n;return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this.isConnected){t.next=2;break}return t.abrupt("return");case 2:if(this.updateVariantPricingData(),this.variantId){t.next=5;break}return t.abrupt("return");case 5:return t.prev=5,t.next=8,fetch("".concat(window.Shopify.routes.root,"cart.js"));case 8:return e=t.sent,t.next=11,e.json();case 11:if(n=t.sent,this.isConnected){t.next=14;break}return t.abrupt("return");case 14:this.cartQuantitiesByKey=buildCartQuantityMap(n.items),this.cartQuantity=this.getCartQuantityForCurrentSelection(),t.next=22;break;case 18:t.prev=18,t.t0=t.catch(5),this.cartQuantity=0,this.cartQuantitiesByKey={};case 22:case"end":return t.stop()}}),t,this,[[5,18]])}))),function(){return e.apply(this,arguments)})},{key:"getFormPropertyInputs",value:function(){var t,e=null===(t=this.inputElement)||void 0===t?void 0:t.form;if(!e)return [];var n=e.getAttribute("id"),i=new Set;return e.querySelectorAll('input[name^="properties["]').forEach((function(t){return i.add(t)})),n&&document.querySelectorAll('input[name^="properties["][form="'.concat(n,'"]')).forEach((function(t){return i.add(t)})),Array.from(i)}},{key:"getCurrentFinishKey",value:function(){var t=this.getFormPropertyInputs(),e={};return t.forEach((function(t){if(!t.disabled){var n=(t.getAttribute("name")||"").match(/^properties\[(.+)\]$/);n&&(e[n[1]]=t.value);}})),buildFinishKeyFromProperties(e)}},{key:"getCurrentAggregationKey",value:function(){return this.updateVariantPricingData(),"".concat(this.variantId||"","|").concat(this.getCurrentFinishKey())}},{key:"getCartQuantityForCurrentSelection",value:function(){var t=this.getCurrentAggregationKey();return this.cartQuantitiesByKey[t]||0}},{key:"getCurrentPrice",value:function(t){this.updateVariantPricingData();for(var e=parseInt(t,10)+this.getCartQuantityForCurrentSelection(),n=this.quantityPriceBreaks.length-1;n>=0;n-=1){var i=this.quantityPriceBreaks[n];if(e>=i.min)return Math.round(i.price*getProductPriceMultiplier())}return Math.round(this.defaultPrice*getProductPriceMultiplier())}},{key:"updatePrice",value:function(){if(this.isConnected&&this.inputElement&&0!==this.quantityPriceBreaks.length){var t=parseInt(this.inputElement.value,10)||1,e=this.getCurrentPrice(t),n=this.closest(".product-info"),i=null==n?void 0:n.querySelector(".product-info__price price-list");if(i){var r=i.querySelector("sale-price");if(r){var l=a.formatPrice(e);r.innerHTML='<span class="sr-only">Angebot</span>'.concat(l);}}}}},{key:"disconnectedCallback",value:function(){this.abortController.abort();}}],[{key:"formatPrice",value:function(t){return "€".concat((t/100).toFixed(2).replace(".",","))}}]),a}(_wrapNativeSuper(HTMLElement));window.customElements.get("catalog-quantity-selector")||window.customElements.define("catalog-quantity-selector",CatalogQuantitySelector),function(){var t="[data-volume-pricing-dropdown-block]",e="[data-koziol-volume-pricing-dropdown]",n=new WeakMap;function i(t){if(n.has(t))return n.get(t);var e=t.querySelector("script[data-volume-pricing-variants]");if(!e)return n.set(t,{}),{};try{var i=JSON.parse(e.textContent||"{}");return n.set(t,i&&"object"===_typeof(i)?i:{}),n.get(t)}catch(e){return n.set(t,{}),{}}}function a(t){var e=t.getAttribute("data-quantity-input-id");if(e){var n=document.getElementById(e);if(n)return n}var i=t.closest(".product-info")||document;return i.querySelector('catalog-quantity-selector input.quantity-selector__input[name="quantity"]')||i.querySelector('input.quantity-selector__input[name="quantity"]')||i.querySelector('input[name="quantity"][is="quantity-input"]')||null}function r(t,e){var n=t.querySelector(".koziol-pdp-dropdown__form-label");n&&(n.textContent=(null==e?void 0:e.label)||"");var i=t.querySelector(".koziol-pdp-dropdown__form-value");i&&(i.textContent=(null==e?void 0:e.priceDisplay)||"");var a=t.querySelector(".koziol-pdp-dropdown__badge");if(a){var r=(null==e?void 0:e.badge)||"";r?(a.textContent=r,a.removeAttribute("hidden")):(a.textContent="",a.setAttribute("hidden",""));}}function l(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=document.createElement("div");i.className="koziol-pdp-dropdown__panel-row".concat(e?" koziol-pdp-dropdown__panel-row--first":""),i.setAttribute("data-volume-pricing-min",String(t.min||"")),n?i.setAttribute("data-selected","true"):i.removeAttribute("data-selected");var a=document.createElement("span");a.className="koziol-pdp-dropdown__panel-left",a.textContent=t.label||"";var r=document.createElement("span");r.className="koziol-pdp-dropdown__panel-right";var l=document.createElement("span");l.className="koziol-pdp-dropdown__panel-price",l.textContent=t.priceDisplay||"";var u=document.createElement("span");return u.className="koziol-pdp-dropdown__badge",t.badge?(u.textContent=t.badge,u.removeAttribute("hidden")):(u.textContent="",u.setAttribute("hidden","")),r.append(l,u),i.append(a,r),i}function u(t,e){if(!Array.isArray(t)||0===t.length)return null;for(var n=t.length-1;n>=0;n-=1){var i=t[n];if(e>=(i.min||0))return i}return null}function o(t,n){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,s=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,c=t.querySelector(e);if(c){var d=a(c);if(d){var p=d.getAttribute("form");p&&!c.getAttribute("data-form-id")&&c.setAttribute("data-form-id",p),d.id&&!c.getAttribute("data-quantity-input-id")&&c.setAttribute("data-quantity-input-id",d.id);}var h=i(t),m=n?String(n):"",v=h[m],g=Array.isArray(null==v?void 0:v.tiers)?v.tiers:[];c.setAttribute("data-current-variant-id",m);var f,y=c.querySelector(".koziol-pdp-dropdown__panel");if(y&&(y.innerHTML=""),!g.length)return t.setAttribute("hidden",""),void r(c,null);var b=!1;if(null!==o)f=g.find((function(t){return String(t.min)===String(o)}))||g[0];else if(null!==s){if(!(f=u(g,s))){var E=_slicedToArray(g,1);f=E[0],b=!0;}}else {var C=_slicedToArray(g,1);f=C[0];}if(t.removeAttribute("hidden"),b?c.removeAttribute("data-selected-min"):c.setAttribute("data-selected-min",String(f.min||"")),r(c,f),y){var k=b?g:g.filter((function(t){return String(t.min)!==String(f.min)}));k.forEach((function(t,e){y.appendChild(l(t,0===e,!1));}));}}}function s(){document.querySelectorAll(t).forEach((function(t){var n=t.querySelector(e);if(n&&!n.hasAttribute("data-volume-pricing-initialized")){n.setAttribute("data-volume-pricing-initialized","");var i=n.getAttribute("data-current-variant-id");i&&o(t,i);}}));}document.addEventListener("click",(function(n){var i=n.target.closest("[data-volume-pricing-min]");if(i){var r=i.closest(e);if(r){var l=i.closest(t),u=a(r);if(u){var s=i.getAttribute("data-volume-pricing-min");!function(t,e){if(t){var n=parseInt(e,10);Number.isFinite(n)&&(t.value=String(n),t.dispatchEvent(new Event("input",{bubbles:!0})),t.dispatchEvent(new Event("change",{bubbles:!0})));}}(u,s);var c=r.getAttribute("data-current-variant-id")||null;l&&o(l,c,s);}}}}),!0),document.addEventListener("variant:change",(function(n){var i=n.detail&&n.detail.variant,r=n.detail&&n.detail.formId,l=i&&i.id;l&&document.querySelectorAll(t).forEach((function(t){var n,i=t.querySelector(e);if(i){var u=i.getAttribute("data-form-id")||(null===(n=a(i))||void 0===n?void 0:n.getAttribute("form"));r&&u&&r!==u||o(t,l);}}));}),!0);var c=function(n){var i=n.target;if(i&&i.matches('input[name="quantity"]')){var a=function(t){if(!t)return null;var e=parseInt(t.value,10);return Number.isNaN(e)?null:e}(i);null!==a&&document.querySelectorAll(t).forEach((function(t){var n=t.querySelector(e);if(n){var i=n.getAttribute("data-current-variant-id");i&&o(t,i,null,a);}}));}};document.addEventListener("input",c),document.addEventListener("change",c),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",s):s(),document.addEventListener("shopify:section:load",s);}();})();